import { render } from "./ViewDataPendaftaran.vue?vue&type=template&id=2e5a5562"
import script from "./ViewDataPendaftaran.vue?vue&type=script&lang=js"
export * from "./ViewDataPendaftaran.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__